import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import { useEffect } from 'react';
import './Loader.css';

interface LoaderProps {
  message?: string;
}

export const Loader: React.FC<LoaderProps> = ({
  message: _message = 'Initializing Genetrix...',
}) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));

  useEffect(() => {
    const animation = animate(count, 100, {
      duration: 4.3,
      ease: 'easeOut',
    });

    return animation.stop;
  }, [count]);

  return (
    <motion.div
      className="loader-container"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="progress-counter"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.5 }}
      >
        <motion.span className="counter-number">{rounded}</motion.span>
        <span className="counter-percent">%</span>
      </motion.div>
    </motion.div>
  );
};
